<template>
  <el-aside width="256px" class="leftMenu">
    <div class="logo">
      <!-- <img src="@/assets/images/logo_default.png" alt=""> -->
       <img src="@/assets/images/mlogo.png" alt="">
       <div class="t">中小企业智能合规系统</div>
       <img class="line" src="@/assets/images/line.png" alt="">
    </div>
    <el-menu ref="sideMenu" :default-active="activeMenu" router :collapse="isCollapse">
      <template v-for="route in menuList">
        <!-- 有子路由的菜单项 -->
        <el-submenu 
          v-if="route.children && route.children.length > 0 && !route.meta?.hiddenSubMenu"
          :key="route.path"
          :index="route.path"
        >
          <template slot="title">
            <span class="iconImg" :style="getIconStyle(route.meta.icon)"></span>
            <span slot="title">{{ route.meta.title }}</span>
          </template>
          
          <el-menu-item 
            v-for="child in route.children.filter(r => !r.meta?.hidden)"
            :key="child.path"
            :index="route.path + '/' + child.path"
          >
             <span class="iconImg" :style="getIconStyle(route.meta.icon)"></span>
            <span slot="title">{{ route.meta.title }}</span>
          </el-menu-item>
        </el-submenu>
        
        <!-- 单层菜单项 -->
        <el-menu-item 
          v-else-if="!route.meta?.hidden" :key="route.path" :index="route.path">
           <span class="iconImg" :style="getIconStyle(route.meta.icon)"></span>
          <span slot="title">{{ route.meta.title }}</span>
        </el-menu-item>
      </template>
    </el-menu>
    <div class="footer">
      <img src="@/assets/images/zhuangshi.png" alt="">
      <div class="fBtn"><span class="icon" :style="getIconStyle('setting')"></span>系统设置</div>
      <div class="fBtn active" @click="exitLogin"><span class="icon" :style="getIconStyle('exit')"></span>退出登录</div>
    </div>
  </el-aside>
</template>

<script>
export default {
  name: 'SideMenu',   // 递归组件需要 name
  props: {
    menuList: {
      type: Array,
      default: () => []
    },
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  computed: {
    // 关键：匹配父路由保持高亮
    activeMenu() {
      const route = this.$route
      const { meta, path, matched } = route
      
      // 1. 优先使用 meta 中指定的 activeMenu
      if (meta?.activeMenu) {
        return meta.activeMenu
      }

      // 如果当前是根路径 '/'，找重定向的目标
      if (path === '/') {
        const redirectRoute = matched[0]?.redirect
        if (redirectRoute) {
          return redirectRoute
        }
      }
      
      // 2. 匹配父路由：如果当前路径是子路由，找到对应的父菜单
      // matched[0] 是根路由 /，matched[1] 是父路由如 /RiskAtlas
      if (matched.length > 1) {
        const parentRoute = matched[1] // 获取父级路由
        // 检查该父路由是否在 menuList 中
        const exists = this.menuList.find(item => item.path === parentRoute.path)
        if (exists) {
          return parentRoute.path
        }
      }
      
      // 3. 默认返回当前路径
      return path
    }
  },
  watch: {
    // 监听路由变化，手动更新菜单高亮
    '$route': {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          if (this.$refs.sideMenu) {
            this.$refs.sideMenu.activeIndex = this.activeMenu
          }
        })
      }
    }
  },
  methods: {
    exitLogin() {
      console.log('退出登录');
      sessionStorage.clear()           // 清空所有 sessionStorage
      window.location.reload()  // 强制刷新跳转，清除所有状态
    },
    getIconStyle(iconName) {
      return {
        '--bg-normal': `url(${require('@/assets/images/icon_' + iconName + '.png')})`,
        '--bg-active': `url(${require('@/assets/images/icon_' + iconName + '_active.png')})`
      }
    }
  },
  created() {
  }
}
</script>
<style lang="less" scoped>
  .leftMenu {
    width: 256px;
    height: 100vh;
    background-color: #0F1E4B;
    border-radius: 0 40px 40px 0;
    box-shadow: 4px 0 20px 0 rgba(10,21,64,0.15);
    position: relative;
    .logo {
      text-align: center;
      margin: 30px 0;
      img {
        width: 134px;
        &.line {
          width: 199px;
          height: 1px;
        }
      }
      .t {
        font-size: 12px;
        color: #B9C3C2;
        width: 134px;
        height: 20px;
        background-color: #2A3760;
        line-height: 20px;
        text-align: center;
        border-radius: 10px;
        margin: 0 auto;
      }
    }
    .el-menu {
      background-color: transparent;
      border-right: 0;
      .el-menu-item {
        height: auto;
        color: #333;
        text-align: center;
        padding: 15px 0 !important;
        font-size: 14px;
        color: #94A3B8;
        line-height: normal;
        &::after {
          content: '';
          width: 15px;
          height: 1px;
          background-color: #596486;
          display: block;
          margin: 10px auto 0;
        }
        .iconImg {
          display: block;
          width: 45px;
          height: 45px;
          background-image: var(--bg-normal);
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          margin-right: 3px;
          margin: 0 auto;
        }
        &:hover, &.is-active {
          background: transparent;
          color: #8ED5FF;
          font-size: 17px;
          .iconImg {
            width: 54px;
            height: 54px;
            background-image: var(--bg-active);
          }
        }
      }
      
    }
    .footer {
      text-align: center;
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 10px;
      img {
        width: 230px;
      }
      .fBtn {
        width: 216px;
        height: 48px;
        margin: 10px auto 5px;
        text-align: center;
        font-size: 16px;
        color: #94A3B8;
        line-height: 48px;
        border-radius: 24px;
        cursor: pointer;
        .icon {
          width: 24px;
          height: 24px;
          display: inline-block;
          background-image: var(--bg-normal);
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          margin-right: 5px;
          vertical-align: middle;
        }
        &:hover, &.active {
          color: #fff;
          background-color: #0052D9;
          .icon {
            background-image: var(--bg-active);
          }
        }
      }
    }
  }
</style>